module.exports = __webpack_public_path__ + "static/mail-05cf03134c75ed08c4735a7ad5af1778.svg";